import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Button, Input, Table, Icon } from 'antd';
import Highlighter from 'react-highlight-words';

const { Search } = Input;

@inject('ItemRoomTypeStore')
@observer
class ItemRoomTypeSearchRoomModalPage extends Component {
    constructor(props) {
        super(props)
        this.state = {
            searchText: '',
            searchedColumn: ''
        }
    }

    componentDidMount() {
    }

    getColumns = () => {
        return [
            {
                title: 'Item',
                dataIndex: 'taskName',
                key: 'taskName',
                width: '45%',
                ...this.getColumnSearchProps('taskName')
            },
            {
                title: 'Category/Sub Category',
                dataIndex: 'parentName',
                key: 'parentName',
                width: '45%',
                ...this.getColumnSearchProps('parentName')
            },
            {
                title: 'Action',
                dataIndex: 'taskId',
                key: 'taskId',
                width: '10%',
                render: record => {
                    const { taskID } = this.props.ItemRoomTypeStore;

                    if (taskID !== record)
                        return (
                            <span>
                                <Button onClick={() => this.selectItemonClick(record)} type='primary'>
                                    Select
                            </Button>
                            </span>
                        )
                },
            },
        ]
    }

    getColumnSearchProps = dataIndex => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={node => {
                        this.searchInput = node
                    }}
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                <Button
                    type='primary'
                    onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                    icon='search'
                    size='small'
                    style={{ width: 90, marginRight: 8 }}
                >
                    Search
            </Button>
                <Button onClick={() => this.handleReset(clearFilters)} size='small' style={{ width: 90 }}>
                    Reset
            </Button>
            </div>
        ),
        filterIcon: filtered => (
            <Icon type='search' style={{ color: filtered ? '#1890ff' : undefined }} />
        ),
        onFilter: (value, record) => record[dataIndex] ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase()) : null,
        onFilterDropdownVisibleChange: visible => {
            if (visible) {
                setTimeout(() => this.searchInput.select())
            }
        },
        render: text =>
            this.state.searchedColumn === dataIndex ? (
                <Highlighter
                    highlightStyle={{ padding: 0 }}
                    searchWords={[this.state.searchText]}
                    autoEscape
                    textToHighlight={text ? text.toString() : ''}
                />
            ) : (
                text
            ),
    });

    handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm()
        this.setState({
            searchText: selectedKeys[0],
            searchedColumn: dataIndex,
        });
    };

    handleReset = clearFilters => {
        clearFilters()
        this.setState({ searchText: '' })
    }

    // ON CHANGE

    itemOnChange = e => {
        this.props.ItemRoomTypeStore.setItemSearchValue(e.target.value);
        this.props.ItemRoomTypeStore.searchItem();
    }

    // ON CLICK

    selectItemonClick = taskID => {
        this.props.ItemRoomTypeStore.searchItemSelected(taskID);
        this.props.ItemRoomTypeStore.setShowItemSearchModal(false);
    }

    render() {
        const {
            itemFilter,
            itemSearchValue
        } = this.props.ItemRoomTypeStore;

        return (
            <React.Fragment>
                <Search style={{ marginBottom: 10 }} placeholder='Search Item' value={itemSearchValue} onChange={this.itemOnChange} />
                <Table columns={this.getColumns()} dataSource={itemFilter} />
            </React.Fragment>
        )
    }
}

export default ItemRoomTypeSearchRoomModalPage;